import { Component } from 'preact'
import InputGroup from '../ui-components/InputGroup'
import RadioInputGroup from '../ui-components/RadioInputGroup'
import QuickLinkUploader from './QuickLinkUploader'
import Switcher from '../control/Switcher'
import ButtonControl from '../button-control'

class QuickLinkModal extends Component {
  constructor (props) {
    super()
    this.state = props.item ? this.generateStateFromItem(props.item) : this.getDefaultState()
    this.fileInputId = 'quick-link-file-input'
  }

  getDefaultState () {
    return {
      quickLink: {
        title: '',
        url: '',
        description: '',
        openNewTab: false,
        imageSrc: null,
        iconSrc: null
      },
      visual: 'None',
      openFileDialog: false
    }
  }

  generateStateFromItem (item) {
    let visual = 'None'
    if (item.iconSrc) {
      visual = 'Icon'
    }
    if (item.imageSrc) {
      visual = 'Image'
    }
    return {
      quickLink: item,
      visual: visual,
      openFileDialog: false
    }
  }

  setValue (field, value) {
    this.setState({ openFileDialog: false, quickLink: Object.assign({}, this.state.quickLink, { [field]: value }) })
  }

  setVisual (option) {
    let quickLink = this.state.quickLink
    switch (option) {
      case 'None':
        quickLink = Object.assign({}, quickLink, { imageSrc: null, iconSrc: null })
        break
      case 'Image':
        quickLink = Object.assign({}, quickLink, { iconSrc: null })
        break
      case 'Icon':
        quickLink = Object.assign({}, quickLink, { imageSrc: null })
        break
    }
    this.setState({ openFileDialog: false, visual: option, quickLink: quickLink })
  }

  deleteImage () {
    this.setState({ openFileDialog: false, visual: 'None', quickLink: Object.assign({}, this.state.quickLink, { imageSrc: null, iconSrc: null }) })
  }

  editImage () {
    this.setState({ openFileDialog: true, quickLink: Object.assign({}, this.state.quickLink, { imageSrc: null, iconSrc: null }) })
  }

  imageUploaded (response) {
    let quickLink = this.state.quickLink
    if (this.state.visual === 'Icon') {
      quickLink = Object.assign({}, quickLink, { iconSrc: response })
    }
    if (this.state.visual === 'Image') {
      quickLink = Object.assign({}, quickLink, { imageSrc: response })
    }
    this.setState({ openFileDialog: false, quickLink: quickLink })
  }

  componentDidUpdate () {
    if (this.state.openFileDialog === true) {
      document.getElementById(this.fileInputId).click()
    }
  }

  render (props, state) {
    const quickLink = state.quickLink
    const visualType = {
      Icon: {
        src: state.quickLink.iconSrc,
        label: 'Upload icon',
        width: 224,
        height: 224
      },
      Image: {
        src: state.quickLink.imageSrc,
        label: 'Upload image',
        width: 720,
        height: 272
      },
      None: {}
    }
    const src = visualType[state.visual].src || null
    const showUploader = !src && state.visual !== 'None'

    return <form className='quick-link-modal' onSubmit={(e) => { e.preventDefault(); props.onSubmit(state.quickLink) }}>
      <h3>{props.item ? 'Edit quick link' : 'Add quick link'}</h3>
      <InputGroup title={'Title'} type={'text'} required maxlength={30} onChange={(e) => this.setValue('title', e.target.value)} value={quickLink.title} qaClasses={'qa-quicklinks-input-title'} />
      <InputGroup title={'Link'} type={'url'} required onChange={(e) => this.setValue('url', e.target.value)} value={quickLink.url} placeholder={'https://example.com'} pattern={'https?://.+'} qaClasses={'qa-quicklinks-input-url'} />
      <div class='clearfix'>
        <Switcher on={quickLink.openNewTab} onChange={() => this.setValue('openNewTab', !quickLink.openNewTab)} label={'Open link in new tab'} />
      </div>
      <InputGroup title={'Description (optional)'} type={'text'} maxlength={80} onChange={(e) => this.setValue('description', e.target.value)} value={quickLink.description} qaClasses={'qa-quicklinks-input-description'} />
      <RadioInputGroup title={'Visual'} options={['None', 'Icon', 'Image']} onChange={(e) => this.setVisual(e)} value={state.visual} />
      { src
        ? <div className={'preview'}>
          <div className={'img-container'}>
            <img src={src} />
          </div>
          <div className={'buttons-container'}>
            <button className={'btn btn-default qa-quicklinks-image-edit'} onClick={(e) => { e.preventDefault(); this.editImage() }}>Edit</button>
            <button className={'btn btn-danger qa-quicklinks-image-delete'} onClick={(e) => { e.preventDefault(); this.deleteImage() }}>Delete</button>
          </div>
        </div>
        : null}
      { showUploader
        ? <QuickLinkUploader
          width={visualType[state.visual].width}
          height={visualType[state.visual].height}
          label={visualType[state.visual].label}
          restriction={visualType[state.visual].restriction}
          onUploaded={(response) => this.imageUploaded(response)}
          fileInputId={this.fileInputId}
        />
        : null }
      <ButtonControl
        class='qa-quicklinks-modal-save'
        title='Save changes'
        variant='success'
        type='submit'
        disabled={showUploader}
      />
    </form>
  }
}

export default QuickLinkModal
